export default __webpack_public_path__ + "static/media/Anexo-azul.f3d1ecf1.svg";